import { useRouter } from '@tanstack/react-router'
import type * as React from 'react'

/**
 * Link para uma tela do próprio painel, por caminho em texto (ex.: `/gestao/alertas`).
 * Navega sem recarregar a página; Ctrl/Cmd+clique e botão do meio abrem em outra aba.
 */
export function LinkInterno({
  para,
  onClick,
  ...props
}: Omit<React.ComponentProps<'a'>, 'href'> & { para: string }) {
  const router = useRouter()
  return (
    <a
      {...props}
      href={para}
      onClick={(evento) => {
        onClick?.(evento)
        if (evento.defaultPrevented) return
        if (evento.ctrlKey || evento.metaKey || evento.shiftKey || evento.button !== 0) return
        if (props.target === '_blank') return
        evento.preventDefault()
        router.history.push(para)
      }}
    />
  )
}
